import { QUERY_KEYS } from "@forwardflow/helpers/utils/constants";
import SubscriptionService from "@forwardflow/services/SubscriptionService";
import { useState } from "react";
import useSWR from "swr";

export function useGetUserSubscription() {
  const [shouldRetry, setShouldRetry] = useState(true);
  const response = useSWR(
    shouldRetry ? [QUERY_KEYS.SUBSCRIBED_PACKAGE] : null,
    () => SubscriptionService.getUserSubscription(),
    {
      onError: (error) => {
        if (error.response.status === 404) {
          setShouldRetry(false);
        }
      },
    }
  );
  return {
    ...response,
  };
}
